import { Expose, Transform } from 'class-transformer';
import { DrupalBase, DrupalIdentifier } from '@nx-icilalune/drupal-types';

export type Paragraphs =
  | typeof ParagraphText.type
  | typeof ParagraphMedia.type
  | typeof ParagraphQuote.type
  | typeof ParagraphCode.type
  | typeof ParagraphContentLinks.type;

export type ParagraphClasses =
  | ParagraphText
  | ParagraphMedia
  | ParagraphQuote
  | ParagraphCode
  | ParagraphContentLinks;

export class Paragraph extends DrupalBase {
  @Transform(({ obj }) => {
    return obj?.attributes?.header_title;
  })
  @Expose()
  title?: string;
}

export class ParagraphText extends Paragraph {
  public static readonly type = 'paragraph--paragraph_texte';

  @Transform(({ obj }) => {
    return obj?.attributes?.paragraph_body?.processed;
  })
  @Expose()
  body!: string;
}

export class ParagraphImages extends Paragraph {
  public static readonly type = 'paragraph--images';

  @Transform(({ obj }) => {
    return obj?.relationships?.field_images?.data;
  })
  @Expose()
  field_images!: string;
}

export class ParagraphMedia extends Paragraph {
  public static readonly type = 'paragraph--paragraph_media';

  @Transform(({ obj }) => {
    return obj?.relationships?.images?.data || undefined;
  })
  @Expose()
  media!: DrupalIdentifier[] | undefined;

  @Transform(({ obj }) => {
    return obj?.attributes?.autoplay;
  })
  @Expose()
  autoplay!: boolean;

  @Transform(({ obj }) => {
    return obj?.attributes?.custom_css;
  })
  @Expose()
  classes!: string;

  @Transform(({ obj }) => {
    return obj?.attributes?.ratio;
  })
  @Expose()
  aspectRatio: string | undefined;
}

export class ParagraphQuote extends Paragraph {
  public static readonly type = 'paragraph--paragraph_quote';

  @Transform(({ obj }) => {
    return obj?.relationships?.author?.data || undefined;
  })
  @Expose()
  profile!: DrupalIdentifier | undefined;

  @Transform(({ obj }) => {
    return obj?.attributes?.quote_text;
  })
  @Expose()
  quote!: string;
}

export class ParagraphCode extends Paragraph {
  public static readonly type = 'paragraph--paragraph_code';

  @Transform(({ obj }) => {
    return obj?.attributes?.code;
  })
  @Expose()
  sample!: string;
}

export class ParagraphContentLinks extends Paragraph {
  public static readonly type = 'paragraph--paragraph_content_links';

  @Transform(({ obj }) => {
    return obj?.relationships?.linked_content?.data || undefined;
  })
  @Expose()
  linkedContents!: DrupalIdentifier[] | undefined;
}
